// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy, mockSpecifiedItems } from './shared';

export const label = 'Contents - Expired';

export const policy: Policy = createMockPolicy({
  policyNumber: 'C02/16544265',
  policyDetailsId: '121811235875',
  forename: 'Albert',
  coverType: 'Contents',
  inceptionDate: '8 Jan 2022',
  startDate: '8 Feb 2022',
  endDate: '8 Feb 2023',
  accidentalDamageLevel: { Buildings: 'Full', Contents: 'Basic' },
  specifiedItems: mockSpecifiedItems,
  personalPossessionsSumInsured: 550
});
